<div [ngClass]="{'tab-pane': true, active: isActive}">
  <div class="timeline timeline-inverse">
    <div class="time-label">
      <span class="bg-danger">10 Feb. 2014</span>
    </div>
    <div>
      <i class="fas fa-envelope bg-primary"></i>
      <div class="timeline-item">
        <span class="time">
          <i class="far fa-clock"></i>
          <span> 12:05</span>
        </span>
        <h3 class="timeline-header">
          <a routerLink="/">Support Team</a>
          <span> sent you an email</span>
        </h3>
        <div class="timeline-body">
          Etsy doostang zoodles disqus groupon greplin oooj voxy
          zoodles, weebly ning heekya handango imeem plugg dopplr
          jibjab, movity jajah plickers sifteo edmodo ifttt zimbra.
          Babblely odeo kaboodle quora plaxo ideeli hulu weebly
          balihoo...
        </div>
        <div class="timeline-footer">
          <a routerLink="/" class="btn btn-primary btn-sm mr-2">Read more</a>
          <a routerLink="/" class="btn btn-danger btn-sm">Delete</a>
        </div>
      </div>
    </div>
    <div>
      <i class="fas fa-user bg-info"></i>
      <div class="timeline-item">
        <span class="time">
          <i class="far fa-clock"></i>
          <span> 5 mins ago</span>
        </span>
        <h3 class="timeline-header border-0">
          <a routerLink="/">Sarah Young</a>
          <span> accepted your friend request</span>
        </h3>
      </div>
    </div>
    <div>
      <i class="fas fa-comments bg-warning"></i>
      <div class="timeline-item">
        <span class="time">
          <i class="far fa-clock"></i>
          <span> 27 mins ago</span>
        </span>
        <h3 class="timeline-header">
          <a routerLink="/">Jay White</a>
          <span> commented on your post</span>
        </h3>
        <div class="timeline-body">
          Take me to your leader! Switzerland is small and neutral! We
          are more like Germany, ambitious and misunderstood!
        </div>
        <div class="timeline-footer">
          <a routerLink="/" class="btn btn-warning btn-flat btn-sm">View comment</a>
        </div>
      </div>
    </div>
    <div class="time-label">
      <span class="bg-success">3 Jan. 2014</span>
    </div>
    <div>
      <i class="fas fa-camera bg-purple"></i>
      <div class="timeline-item">
        <span class="time">
          <i class="far fa-clock"></i>
          <span> 2 days ago</span>
        </span>
        <h3 class="timeline-header">
          <a routerLink="/">Mina Lee</a>
          <span> uploaded new photos</span>
        </h3>
        <div class="timeline-body">
          <!-- <pf-image
                        src="assets/img/default-profile.png"
                        width="25"
                        height="25"
                        class="mr-1"
                    />
                    <pf-image
                        src="assets/img/default-profile.png"
                        width="25"
                        height="25"
                        class="mr-1"
                    />
                    <pf-image
                        src="assets/img/default-profile.png"
                        width="25"
                        height="25"
                        class="mr-1"
                    />
                    <pf-image
                        src="assets/img/default-profile.png"
                        width="25"
                        height="25"
                        class="mr-1"
                    /> -->
        </div>
      </div>
    </div>
    <div>
      <i class="far fa-clock bg-gray"></i>
    </div>
  </div>
</div>
